module.exports = __webpack_public_path__ + "img/9mobile.6d68b121.png";